import { createReducer } from 'src/helpers/reducer';
import actions from './actions';
import type { IJobTypesMutationsState, IValidations } from './types';

const initState: IJobTypesMutationsState = {
  isCreating: false,
  createFailed: false,
  createErrors: null,
  isRenaming: false,
  renameFailed: false,
  renameErrors: null,
  isDeleting: false,
  deleteFailed: false,
};

type ValidationsAction = { payload: { validations: IValidations | null } };

function onCreateRequest(state: IJobTypesMutationsState): IJobTypesMutationsState {
  return { ...state, isCreating: true, createFailed: false, createErrors: null };
}

function onCreateSuccess(state: IJobTypesMutationsState): IJobTypesMutationsState {
  return { ...state, isCreating: false, createFailed: false, createErrors: null };
}

function onCreateError(state: IJobTypesMutationsState, { payload }: ValidationsAction): IJobTypesMutationsState {
  return { ...state, isCreating: false, createFailed: true, createErrors: payload.validations };
}

function onRenameRequest(state: IJobTypesMutationsState): IJobTypesMutationsState {
  return { ...state, isRenaming: true, renameFailed: false, renameErrors: null };
}

function onRenameSuccess(state: IJobTypesMutationsState): IJobTypesMutationsState {
  return { ...state, isRenaming: false, renameFailed: false, renameErrors: null };
}

function onRenameError(state: IJobTypesMutationsState, { payload }: ValidationsAction): IJobTypesMutationsState {
  return { ...state, isRenaming: false, renameFailed: true, renameErrors: payload.validations };
}

function onDeleteRequest(state: IJobTypesMutationsState): IJobTypesMutationsState {
  return { ...state, isDeleting: true, deleteFailed: false };
}

function onDeleteSuccess(state: IJobTypesMutationsState): IJobTypesMutationsState {
  return { ...state, isDeleting: false, deleteFailed: false };
}

function onDeleteError(state: IJobTypesMutationsState): IJobTypesMutationsState {
  return { ...state, isDeleting: false, deleteFailed: true };
}

export default createReducer(initState, {
  [actions.CREATE_REQUEST]: onCreateRequest,
  [actions.CREATE_SUCCESS]: onCreateSuccess,
  [actions.CREATE_ERROR]: onCreateError,
  [actions.RENAME_REQUEST]: onRenameRequest,
  [actions.RENAME_SUCCESS]: onRenameSuccess,
  [actions.RENAME_ERROR]: onRenameError,
  [actions.DELETE_REQUEST]: onDeleteRequest,
  [actions.DELETE_SUCCESS]: onDeleteSuccess,
  [actions.DELETE_ERROR]: onDeleteError,
  [actions.CLEAR_STORE]: () => initState,
});
